<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider">智能助手</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h5 id="title">智能助手</h5>
          <hr>
          <div class="chatArea">
            <div class="chatScroll">
              <div class="chatMessage">
                <div class="chatAvatar"></div>
                <div class="chatBox">
                  <small>易苗小助手</small>
                  <br>
                  <div class="chatContent">
                    请问有什么可以帮助您？
                  </div>
                </div>
              </div>
              <div class="chatMessage">
                <div class="chatBoxR">
                  <small class="chatUserR">黄小饼</small>
                  <br>
                  <div class="chatContentR">
                    hpv疫苗还剩几针
                  </div>
                </div>
                <div class="chatAvatarR"></div>
              </div>
              <div class="chatMessage">
                <div class="chatAvatar"></div>
                <div class="chatBox">
                  <small>易苗小助手</small>
                  <br>
                  <div class="chatContent">
                    HPV疫苗还剩2针。<br>
                    第二次接种日期：2020年8月1日；第三次接种日期：2020年12月1日。
                  </div>
                </div>
              </div>
              <div class="chatMessage">
                <div class="chatBoxR">
                  <small class="chatUserR">黄小饼</small>
                  <br>
                  <div class="chatContentR">
                    hpv疫苗接种注意事项
                  </div>
                </div>
                <div class="chatAvatarR"></div>
              </div>
              <div class="chatMessage">
                <div class="chatAvatar"></div>
                <div class="chatBox">
                  <small>易苗小助手</small>
                  <br>
                  <div class="chatContent">
                    1.什么样的人需要注射HPV疫苗？
                    <br>
                    9-25岁之间尚未有HPV暴露者可以获得较好的免疫效果，对于已经有性生活或者HPV暴露的女性，效果下降。近期的一些研究发现，因为女性有可能在之前只是感染其中一种病毒。因此对于25岁以上的女性，仍然是可以获得一些程度的保护作用。近年来对于佳达修的适应症也是修改为可以接种到9-45岁的女性。
                    <br>
                    2.注射宫颈癌疫苗有什么注意事项？
                    <br>
                    感冒发热的病人不适合接种。
                    <br>
                    3.哪些人群不能打疫苗？
                    <br>
                    如果之前有过对疫苗过敏的人，对酵母菌过敏的人也是禁忌。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
          <b-input class="chatInput"></b-input>
          <b-button class="chatSubmit">发送</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Incomplete",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      items: [],
      data: {
        pid: 0,
        name: "",
        birthday: "",
        gender: "",
        allergen: "",
        medical_history: "",
        province: "",
        city: "",
        district: "",
        contact: "",
        contact_phone: "",
        phone: "",
        email: "",
        address: ""
      }
    }
  },
  mounted() {
    common.assureLogin(this);
    this.axios.post(common.apiBase + common.apiService.getPatient, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      this.data = res.data.data;
      this.data.name = "阿猫"
      this.data.gender = "男"
      this.data.city = "广东省广州市"
      this.data.address = "广东省广州市"
      this.data.contact = "猫父，猫母"
      this.data.contact_phone = "13484839485"
      this.data.phone = "88888888"
      this.data.email = "mao@gmail.com"
      this.data.allergen = "无"
    }).catch((err) => {
      console.log(err);
    });
    this.axios.post(common.apiBase + common.apiService.getNotVaccinated, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      for (let i of res.data.data) {
        this.items.push({
          '疫苗全称': i['name'],
          '防疫疾病': i['disease'],
          '次数': i['dose'],
          '价格': i['cost'],
          '时效': i['effective_time'],
          '建议接种时间': i['advised_time'],
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>

#content {
  padding-left: 2%;
  padding-top: 3vh;
}

#title {
  font-weight: bold;
}

#infos p {
  display: inline-block;
  margin-right: 40px;
  line-height: 10px;
}

.chatArea {
  width: 100%;
  height: 80%;
  max-height: 450px;
}

.chatScroll {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
}

.chatScroll::-webkit-scrollbar {
  width: 0 !important;
}

.chatMessage {
  width: 100%;
  height: 100px;
  position: relative;
  margin-top: 15px;
}

.chatAvatar {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  display: inline-block;
  position: relative;
  top: 0;
  background: #4bb9b7;
}

.chatAvatarR {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  display: inline-block;
  position: relative;
  top: 0;
  left: calc(100% - 60px);
  background: #4bb9b7;
}

.chatBox {
  width: calc(100% - 70px);
  margin-left: 5px;
  display: inline-block;
  position: absolute;
  top: 0;
}

.chatBoxR {
  width: calc(100% - 70px);
  margin-right: 5px;
  display: inline-block;
  position: absolute;
  top: 0;
}

.chatUserR {
  float: right;
}

.chatContent {
  border-radius: 5px;
  display: inline-block;
  padding: 12px;
  background: #e2f2ff;
  max-width: 60%;
}

.chatContentR {
  border-radius: 5px;
  display: inline-block;
  padding: 12px;
  float: right;
  background: #f5fbfb;
  max-width: 60%;
}

.chatInput {
  border-radius: 50px;
  height: 50px;
  border: #4bb9b7 solid 1px;
  position: relative;
}

.chatSubmit {
  border-radius: 50px;
  position: relative;
  top: -44px;
  left: calc(100% - 66px);
}


</style>